import type { EventLevelDef } from '../types';

export const proactiveSource = {
  title: 'Proactive Event Reporting',
  revision: 'Revised 8/19',
  description:
    'For any unplanned event, unsafe action or unsafe condition that has the potential for injury, damage to property or the environment.',
};

export const eventTypes = ['Near Hit', 'Good Catch', 'Time out', 'Other'];

export const relatedCategories = [
  'Motor Vehicle',
  'Mobile Equipment',
  'Falling Objects',
  'LOTO',
  'Caught in/Struck by',
  'Falls',
  'Electrical Contact/Arc Flash',
  'Temperature Extremes',
  'Hazardous Release',
  'Lifting/Rigging',
  'Power tools',
  'Bites & Attacks',
  'Work Permits',
  'Fire',
  'Third Party Hauler',
  'Loading/ Unloading',
  'Other',
];

export const eventLevels: EventLevelDef[] = [
  {
    id: 'I',
    label: 'I Minor',
    description:
      'An event or situation that could have resulted in minor injury (scrape, bruise, graze). Potential for a small spill. Potential property damage cost less than $2,000.',
  },
  {
    id: 'II',
    label: 'II Moderate',
    description:
      'An event or situation that could have resulted in an injury requiring some medical attention, but non SIF (Lacerations, burns, eye irritation, sprain, etc.). Or potential spill or release requiring cleanup assistance from outside contractor. Potential property damage costs between $2,000 and $10,000.',
  },
  {
    id: 'III',
    label: 'III Significant',
    description:
      'An event or situation that could have resulted in significant, but non SIF injury (Lost time, fracture, muscular skeletal, exposure to harmful substance). Or a situation that could have resulted in a major spill release to the environment requiring regulatory reporting, or property damage between $10,000 and $25,000.',
  },
  {
    id: 'IV',
    label: 'IV Major',
    description:
      'An event or situation that could have resulted in a SIF, a major spill directly affecting members of the public or public resources, or property damage greater than $25,000.',
  },
];

export const sifDefinition =
  'SIF (Serious Injury or Fatality): Any life threatening, life altering, or fatal work related injury or illness including any which require immediate life preserving rescue action, result in a permanent and/or significant loss of a body part or organ function, or permanently changes or disables normal life activity.';
